<template>
	<ul class="list-unstyled pagination d-flex" style="gap: 8px">
		<template v-if="firstIf">
			<li
				class="page-item"
				:class="{
					'active bg-primary-blue': page === 0,
				}"
			>
				<div class="page-link-item body-strong" @click="$emit('set-page', 0)">
					1
				</div>
			</li>
			<li v-if="isShowFirstDots" class="page-item page-item--space">
				<div>...</div>
			</li>
		</template>

		<li
			class="page-item text-grey-800"
			v-for="p in pages"
			:class="{
				'active bg-primary-blue': p === page,
			}"
			:key="p"
			@click="$emit('set-page', p)"
		>
			<div class="page-link-item body">
				{{ p + 1 }}
			</div>
		</li>
		<template v-if="lastIf">
			<li v-if="isShowLastDots" class="page-item page-item--space">
				<div>...</div>
			</li>
			<li
				class="page-item"
				:class="{
					'active bg-primary-blue': page === total - 1,
				}"
				@click="$emit('set-page', total - 1)"
			>
				<div class="page-link-item">
					{{ total }}
				</div>
			</li>
		</template>
	</ul>
</template>

<script>
export default {
	name: "Pagination",
	props: {
		page: Number,
		total: Number,
	},
	data() {
		return {
			data: {
				siblings: 2,
			},
			state: {},
		};
	},
	computed: {
		firstIf() {
			return this.page - this.data.siblings > 0;
		},
		lastIf() {
			return (
				this.total !== undefined &&
				this.page + this.data.siblings < this.total - 1
			);
		},
		isShowFirstDots() {
			return this.pages[0] !== 1;
		},
		isShowLastDots() {
			return this.pages[this.pages.length - 1] !== this.total - 2;
		},
		totalValue() {
			return this.total !== undefined ? this.total - 1 : undefined;
		},
		pages() {
			const start = this.page - this.data.siblings;
			const end = this.page + this.data.siblings;
			const pages = [];
			for (let i = start; i <= end; i++) {
				if (i >= 0 && (this.totalValue === undefined || i <= this.totalValue)) {
					pages.push(i);
				}
			}
			return pages;
		},
	},
};
</script>

<style scoped>
.page-link-item:not([disabled]) {
	z-index: 0;
}
.page-item {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 35px;
	height: 35px;
	border-radius: 50%;
	color: #173e67;
	cursor: pointer;
}
.page-item.active {
	/* background:var#173e67; */
	color: #ffffff;
}
.pagination {
	display: flex;
	align-items: center;
	margin-left: 8px;
	margin-bottom: 0px;
}
</style>
